import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { supabase } from '../../core/supabase/supabase.client';

export type WalletAdjustAction = 'credit' | 'debit' | 'set';

export interface AdminRiderWalletDetails {
  rider: {
    id: string;
    full_name?: string;
    code?: string;
    status?: string;
    store_id?: number;
    phone?: string;
  };
  wallet: {
    rider_id: string;
    balance: number;
    pending_balance: number;
    lifetime_earning: number;
    today_earning: number;
    total_orders_completed: number;
    total_payout_withdrawn: number;
    cod_liability: number;
    withdrawable_balance: number;
    updated_at?: string | null;
  };
  recent_transactions: Array<{
    id: number;
    type: string;
    amount: number;
    note: string;
    ref_type?: string | null;
    ref_id?: number | null;
    created_at: string;
  }>;
}

export interface WalletAdjustInput {
  requestId: string;
  riderId: string;
  action: WalletAdjustAction;
  amount: number;
  reason: string;
  adjustLifetime?: boolean;
  adjustCodLiability?: number | null;
}

@Injectable({ providedIn: 'root' })
export class RiderWalletAdminService {
  getWallet(riderId: string): Observable<AdminRiderWalletDetails> {
    return from(
      supabase
        .rpc('admin_get_rider_wallet', { p_rider_id: riderId })
        .then(({ data, error }) => {
          if (error) throw error;
          return data as AdminRiderWalletDetails;
        })
    );
  }

  adjust(input: WalletAdjustInput): Observable<{
    success: boolean;
    balance_before: number;
    balance_after: number;
    delta: number;
  }> {
    return from(
      supabase
        .rpc('admin_adjust_rider_wallet_v2', {
          p_request: input.requestId,
          p_rider_id: input.riderId,
          p_action: input.action,
          p_amount: input.amount,
          p_reason: input.reason,
          p_adjust_lifetime: input.adjustLifetime ?? false,
          p_adjust_cod_liability: input.adjustCodLiability ?? null,
        })
        .then(({ data, error }) => {
          if (error) throw error;
          return data as {
            success: boolean;
            balance_before: number;
            balance_after: number;
            delta: number;
          };
        })
    );
  }
}
